var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.7786,
    height: 39,
    rx: 10.2295,
    fill: "#F7F6F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_14171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7501 13.2495H13.25V25.6336H28.7501V13.2495Z",
    stroke: "#0D4248",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 15.7627H28.7501",
    stroke: "#0D4248",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.822 14.9312C15.0797 14.9312 15.2886 14.7223 15.2886 14.4646C15.2886 14.2069 15.0797 13.998 14.822 13.998C14.5644 13.998 14.3555 14.2069 14.3555 14.4646C14.3555 14.7223 14.5644 14.9312 14.822 14.9312Z",
    fill: "#0D4248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9549 14.9312C17.2125 14.9312 17.4214 14.7223 17.4214 14.4646C17.4214 14.2069 17.2125 13.998 16.9549 13.998C16.6972 13.998 16.4883 14.2069 16.4883 14.4646C16.4883 14.7223 16.6972 14.9312 16.9549 14.9312Z",
    fill: "#0D4248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0877 14.9312C19.3453 14.9312 19.5542 14.7223 19.5542 14.4646C19.5542 14.2069 19.3453 13.998 19.0877 13.998C18.83 13.998 18.6211 14.2069 18.6211 14.4646C18.6211 14.7223 18.83 14.9312 19.0877 14.9312Z",
    fill: "#0D4248"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_14171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12.884,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestIcon);
export default __webpack_public_path__ + "static/media/interestIcon.ba1a102647da69b29a0ae1a32fd32174.svg";
export { ForwardRef as ReactComponent };